<template>
    <b-container>
        <div class="spinner-wrapper">
            <div class="text-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
export default {
    name: 'app-content-loader',

    props: {
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
    .spinner-wrapper {
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .spinner-border {
        border-color: #7347A8;
        border-right-color: transparent;
    }
</style>
